"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isOpenUrlButtonFieldParams = exports.isExecuteAutomationButtonFieldParams = void 0;
const isExecuteAutomationButtonFieldParams = (params) => {
    return params.button_action === "execute_automation";
};
exports.isExecuteAutomationButtonFieldParams = isExecuteAutomationButtonFieldParams;
const isOpenUrlButtonFieldParams = (params) => {
    return params.button_action === "open_url";
};
exports.isOpenUrlButtonFieldParams = isOpenUrlButtonFieldParams;
